import { LucideIcon } from 'lucide-react'

interface StatusCardProps {
  title: string
  value: string | number
  icon: LucideIcon
  subtitle?: string
  color?: 'blue' | 'green' | 'yellow' | 'red' | 'gray'
}

const colorClasses = {
  blue: 'bg-blue-50 text-blue-700 border-blue-200',
  green: 'bg-green-50 text-green-700 border-green-200',
  yellow: 'bg-yellow-50 text-yellow-700 border-yellow-200',
  red: 'bg-red-50 text-red-700 border-red-200',
  gray: 'bg-gray-50 text-gray-700 border-gray-200',
}

export default function StatusCard({
  title,
  value,
  icon: Icon,
  subtitle,
  color = 'blue',
}: StatusCardProps) {
  return (
    <div className={`rounded-lg border p-6 ${colorClasses[color]}`}>
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium opacity-80">{title}</p>
          <p className="text-3xl font-bold mt-2">{value}</p>
          {subtitle && (
            <p className="text-xs mt-1 opacity-70">{subtitle}</p>
          )}
        </div>
        <Icon className="h-12 w-12 opacity-50" />
      </div>
    </div>
  )
}
